export default "__VITE_ASSET__d1867931__"